import ReactGA from 'react-ga4';

// Initialize Google Analytics with environment variable
const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (measurementId) {
    ReactGA.initialize(measurementId);
  } else {
    console.warn('Google Analytics Measurement ID not found in environment variables');
  }
};

// Track page views
const trackPageView = (page) => {
  ReactGA.send({ hitType: 'pageview', page });
};

// Track events
const trackEvent = (category, action, label, value) => {
  ReactGA.event({
    category,
    action,
    label,
    value
  });
};

export { initGA, trackPageView, trackEvent }; 